module.exports = __webpack_public_path__ + "img/report-12377.7d7125ec.7d7125ec.png";